import React from 'react';
import '../styles/components/project.css';
import { projeto1, projeto2, projeto3, projeto4, inProgressGif } from '../assets';
import { useLanguage } from '../contexts/LanguageContext';

interface ProjectData {
  name: string;
  summary: string;
  technologies: string[];
  githubLink?: string;
  liveLink?: string;
  image: string;
  status: 'finished' | 'unfinished';
}

const getStatus = (status: string): 'finished' | 'unfinished' => {
  return (status === 'finished' || status === 'unfinished') ? (status as 'finished' | 'unfinished') : 'finished';
};

const Project: React.FC = () => {
  const { t } = useLanguage();

  const getImage = (imageName: string) => {
    switch (imageName) {
      case 'projeto1.png':
        return projeto1;
      case 'projeto2.png':
        return projeto2;
      case 'projeto3.png':
        return projeto3;
      case 'projeto4.png':
        return projeto4;
      default:
        return '';
    }
  };

  return (
    <div className="projects-container">
      <div className="header-container">
        <h1 className="section-title">{t.projects.title}</h1>
        <p className="section-description">{t.projects.description}</p>
      </div>
      <div className="project-grid">
        {t.projects.items.map((project: any, index: number) => {
          const projectData: ProjectData = {
            ...project,
            status: getStatus(project.status)
          };
          return (
            <div key={index} className={`project-card ${projectData.status}`}>
              <div className="project-image-container">
                <img src={getImage(projectData.image)} alt={projectData.name} className="project-image" />
                {projectData.status === 'unfinished' && (
                  <div className="overlay">
                    <img src={inProgressGif} alt={t.projects.inProgressAlt} className="in-progress-gif" />
                  </div>
                )}
              </div>
              <h2 className="project-name">{projectData.name}</h2>
              <p className="project-summary">{projectData.summary}</p>
              <div className="project-technologies">
                {projectData.technologies.map((tech, techIndex) => (
                  <span key={techIndex} className="technology">{tech}</span>
                ))}
              </div>
              <div className="project-links">
                {projectData.githubLink && (
                  <a href={projectData.githubLink} className="project-link" target="_blank" rel="noopener noreferrer">
                    {t.projects.github}
                  </a>
                )}
                {projectData.liveLink && (
                  <a href={projectData.liveLink} className="project-link" target="_blank" rel="noopener noreferrer">
                    {t.projects.deploy}
                  </a>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Project;
